import { render, staticRenderFns } from "./PlayerController.vue?vue&type=template&id=c384d584&scoped=true&lang=html&"
import script from "./PlayerController.vue?vue&type=script&lang=js&"
export * from "./PlayerController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c384d584",
  null
  
)

export default component.exports